import type { RuleSet } from 'styled-components';

/* @see breakpoints values defined in 'variable.scss' */
const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1800,
  xxxl: 2400,
};

export const mediaQueryEqualOrUpper = (key: keyof typeof breakpoints) => {
  return (style: Readonly<RuleSet>) => `@media (min-width: ${breakpoints[key]}px) { ${style} }`;
};

export const mediaQueryDown = (key: keyof typeof breakpoints) => {
  return (style: Readonly<RuleSet>) => `@media (max-width: ${breakpoints[key]}px) { ${style} }`;
};
